import React, { Fragment, Suspense } from "react";

import { Route, Switch, Router } from "react-router-dom";

import history from "./history";

import withTracker from "./components/GA/Tracker";

import PrivateRoute from "./PrivateRoute";

import { toast, ToastContainer } from "react-toastify";

import { Login, NewPassword, WebApp } from "./DynamicImports";

import * as routes from "./routes";

import "styling/semantic.less";
import "./barestho.css";
import "./baresthoVars.css";
import "react-toastify/dist/ReactToastify.css";
import { Dimmer, Loader } from "semantic-ui-react";

const App = () => (
    <Fragment>
        <Suspense fallback={
            <Dimmer active>
                <Loader />
            </Dimmer>
        }
        >
            <ToastContainer position={toast.POSITION.TOP_CENTER} hideProgressBar={true} autoClose={1800} />
            <Router history={history}>
                <Switch>
                    <Route path={routes.LOGIN} exact component={withTracker(Login)} />
                    <Route path={routes.NEW_PASSWORD} component={withTracker(NewPassword)} />
                    <PrivateRoute path={routes.APP} component={withTracker(WebApp)} />
                    <Route component={withTracker(Login)} />
                </Switch>
            </Router>

        </Suspense>

    </Fragment>
);

export default App



// WEBPACK FOOTER //
// ./src/App.js